import CONFIG from '../configuration/config';

function StatusInfoDemo() {
  return (
    <>
      <div className="program-details-card">
        {/* <h2 className="program-title">{programDB}</h2>
            
            <div className="program-info">
            <p><strong>Tipo de programa:</strong> {programTypeDB}</p>
            {periodDB && <p><strong>Periodo:</strong> {periodDB + '-' + subPeriodDB}</p> } 
            </div> */}
        <div className="status-step">
          <h3 className="text-title close">
            Hola Alex Castellanos
            <button className="logout-button" onClick={logout}>
              Cerrar Sesión
            </button>
          </h3>
          <p className="intro">Aquí verás el estado actual y lo que sigue en tu proceso </p>

          <ul className="items">
            {CONFIG.STATUS?.map((status, index) => (
              <li key={index} className={`item ${index !== 0 ? 'disabled' : ''} `}>
                <div className="left">
                  <h3 className="title">{status.label}</h3>
                  <p className="description">{status.text}</p>
                </div>
                <div className="right">
                  {index === 0 && <i className="fa-solid fa-circle-check icon"></i>}
                  {/* <p className="date">
                dd/mm/aaaa
            </p> */}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div class="status-step"></div>
    </>
  );
}

function logout() {
  localStorage.removeItem(CONFIG.TOKEN);
  window.location.href = CONFIG.URLREDIRECT;
}

export default StatusInfoDemo;
